/* PHANTOM — CRO layer JS */
(function () {
  'use strict';

  /* ---- scroll reveal ---- */
  function reveal() {
    var els = document.querySelectorAll('[data-ph-reveal]:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- sticky add-to-cart (PDP) ---- */
  function stickyAtc() {
    var bar = document.querySelector('[data-ph-sticky]');
    if (!bar) return;
    var form = document.querySelector('product-form form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
    var mainBtn = document.querySelector('.product-form__submit');
    if (!form || !mainBtn) return;

    var btn = bar.querySelector('[data-ph-sticky-btn]');
    var priceEl = bar.querySelector('[data-ph-sticky-price]');
    var subEl = bar.querySelector('[data-ph-sticky-sub]');
    var btnLabel = btn.querySelector('span');
    var idInput = form.querySelector('input[name="id"]');
    var variants = [];
    try { variants = JSON.parse(bar.getAttribute('data-variants') || '[]'); } catch (e) {}

    function money(cents) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: bar.getAttribute('data-currency') || 'USD' }).format(cents / 100); }
      catch (e) { return '$' + (cents / 100).toFixed(2); }
    }
    function sync() {
      var id = idInput ? String(idInput.value) : '';
      var v = variants.filter(function (x) { return String(x.id) === id; })[0];
      if (v) {
        if (priceEl) priceEl.textContent = money(v.price);
        if (subEl) subEl.textContent = v.title === 'Default Title' ? '' : v.title;
        var out = !v.available;
        btn.toggleAttribute('disabled', out);
        if (btnLabel) btnLabel.textContent = out ? bar.getAttribute('data-soldout') : bar.getAttribute('data-add');
      } else {
        var dis = mainBtn.hasAttribute('disabled');
        btn.toggleAttribute('disabled', dis);
        if (btnLabel) btnLabel.textContent = dis ? bar.getAttribute('data-soldout') : bar.getAttribute('data-add');
      }
    }
    sync();
    var mo = new MutationObserver(sync);
    if (idInput) mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    mo.observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });
    document.addEventListener('change', function (e) { if (form.contains(e.target) || e.target.closest('variant-radios, variant-selects, .product-form__input')) setTimeout(sync, 60); });

    btn.addEventListener('click', function () {
      if (btn.hasAttribute('disabled')) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(mainBtn); else mainBtn.click();
    });

    document.body.classList.add('ph-has-sticky');
    var io = new IntersectionObserver(function (entries) {
      var en = entries[0];
      var below = en.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', !en.isIntersecting && below);
    }, { threshold: 0 });
    io.observe(mainBtn);
  }

  /* ---- newsletter status ---- */
  function newsletter() {
    document.querySelectorAll('[data-ph-news]').forEach(function (sec) {
      if (location.hash === '#' + sec.id + '-success' || sec.querySelector('.ph-news__ok')) {
        sec.scrollIntoView({ block: 'center' });
      }
    });
  }

  /* hero: subtract whatever sits above it (announcement bar etc.) so it fits one viewport */
  function heroFit() {
    var hero = document.querySelector('.ph-hero');
    if (!hero) return;
    var set = function () {
      var top = hero.getBoundingClientRect().top + window.scrollY;
      hero.style.setProperty('--ph-hero-offset', Math.max(0, Math.round(top)) + 'px');
    };
    set(); window.addEventListener('resize', set); window.addEventListener('load', set);
  }

  function init() { reveal(); stickyAtc(); newsletter(); heroFit(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { reveal(); });
})();
